import styled from "styled-components";

export const AppContainer = styled.div`
  display: grid;
  gap: 12px;
  grid-template-columns: 340px auto auto;
  grid-template-rows: 52px auto auto;
  grid-template-areas: 
  "fltr srch srch"
  "fltr grd grd"
  "fltr grd grd";

  @media (max-width: 768px) {
    grid-template-columns: none;
    grid-template-rows: none;
    grid-template-areas: 
    "fltr fltr fltr"
    "srch srch srch"
    "grd grd grd";
  }
  
  & * {
    text-transform: initial;
    letter-spacing: normal;
    box-sizing: border-box;
  }
`
